module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"adminVue":"Admin : ","search":"Rechercher","showShared":"inclure les resources des autres comptes","sortBy":"trier par"},"en":{"adminVue":"Admin: ","search":"Search","showShared":"include resources from other accounts","sortBy":"sort by"}}')
  delete Component.options._Ctor
}
